import { Box, Typography } from "@mui/material";

export default function Forbidden() {
  return (
    <Box textAlign="center" height="300px">
      <Typography fontSize={120} lineHeight="normal" sx={{ px: 7, py: 5 }}>
        403
      </Typography>
      <Typography>Нямате нужните права за достъп.</Typography>
    </Box>
  );
}
